import { render, staticRenderFns } from "./workorder.vue?vue&type=template&id=ed03fa20&scoped=true&"
import script from "./workorder.vue?vue&type=script&lang=js&"
export * from "./workorder.vue?vue&type=script&lang=js&"
import style0 from "./workorder.vue?vue&type=style&index=0&id=ed03fa20&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed03fa20",
  null
  
)

export default component.exports